"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isNumber = isNumber;
exports.isObject = isObject;
exports.rangePropType = rangePropType;
exports.valuePropType = valuePropType;
function isNumber(value) {
    return typeof value === "number";
}
function isObject(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object";
}
function rangePropType(props) {
    var maxValue = props.maxValue,
        minValue = props.minValue;


    if (!isNumber(minValue) || !isNumber(maxValue)) {
        return new Error('"minValue" and "maxValue" must be a number');
    }

    if (minValue >= maxValue) {
        return new Error('"minValue" must be smaller than "maxValue"');
    }
}

function valuePropType(props, propName) {
    var maxValue = props.maxValue,
        minValue = props.minValue;

    var value = props[propName];

    if (!isNumber(value) && (!isObject(value) || !isNumber(value.min) || !isNumber(value.max))) {
        return new Error("\"" + propName + "\" must be a number or a range object");
    }

    if (isNumber(value) && (value < minValue || value > maxValue)) {
        return new Error("\"" + propName + "\" must be in between \"minValue\" and \"maxValue\"");
    }

    if (isObject(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
        return new Error("\"" + propName + "\" must be in between \"minValue\" and \"maxValue\"");
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/form/rangePropTypes.js
// module id = 1005
// module chunks = 95715928098905 168707334958949